import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ICONS } from '../assets/icons';
import { getData_menuExterior, getMenuOperaciones } from '../utils';
import { setHistory, setOperacion, okButton, setTiposServicios, showOrdenesPendientes } from '../redux/actions';
import { setDataUser, setContratos, setCurrentContrato, setChequera } from '../redux/actionsServices';
import PosicionCartera from './graphs/posicionCartera';
import DivisasIndicesAcciones from './graphs/divisasIndicesAcciones';
import Reload from './reload';
import 'chartjs-plugin-labels';
import M from 'materialize-css';

import { TEXTOS } from '../properties';
import { getMonthStringGraphs } from '../utils';


import { Bar } from 'react-chartjs-2';


class Graphs extends Component {

    state = {
        contrato: false,
        rendimientos: false,
        monthSistema: false,
        servicios: false,
        permiteCompraVenta: true,
        yearSistema: false,
        dataMenuExterior: false,
        cuentaBancariaDeposito: false,
        imgModal: false,
        configLumina: false,
        menuOperaciones: false
    }

    async componentDidMount() {

        this.props.setHistory(this.props.history);

        if (this.props.dataUser && this.props.dataUser.FechaSistema) {
            let monthSistema = parseInt(this.props.dataUser.FechaSistema.split('-')[1]) - 1;
            let yearSistema = parseInt(this.props.dataUser.FechaSistema.split('-')[0]);
            this.setState({ monthSistema, yearSistema });
        }


        this.getDateMenuExterior();

        this.getMenu_Operaciones();

        M.Modal.init(document.querySelectorAll('.modal_composicion'), {
            dismissible: false,
            opacity: 0
        });

        M.Modal.init(document.querySelectorAll('.modal_composicionLumina'), {
            dismissible: false,
            opacity: 0
        });

        M.Modal.init(document.querySelectorAll('.model_operacion'), {
            dismissible: false
        });

        M.Tooltip.init(document.querySelectorAll('.tooltipped'), {});

        M.Modal.init(document.getElementById('moda_opera_perm'), {});

        console.log("Tipo servicio Opera");
        console.log(this.props.tiposServiciosOpera);

    }

    showModalOperacionPerm = (props) => {
        if (this.state.imgModal) {
            let instance = M.Modal.getInstance(document.getElementById('moda_opera_perm'));

            if (instance) {
                instance.open();
            }
        }
    }

    checkOpera = () => {
        const { currentContrato } = this.props;
        const { configLumina } = this.state;

        if (configLumina) {

            if (currentContrato.PerfilConsulta.toUpperCase() === "TRUE"
                && currentContrato.Consulta == "1") {
                return false;
            } else if (currentContrato.PerfilConsulta.toUpperCase() === "TRUE"
                && currentContrato.Consulta == "0") {
                return false;
            } else if (currentContrato.PerfilConsulta.toUpperCase() === "FALSE"
                && currentContrato.Consulta == "1") {
                return false;
            } else if (currentContrato.PerfilConsulta.toUpperCase() === "FALSE"
                && currentContrato.Consulta == "0") {
                return true;
            }

        } else {

            if (currentContrato.Consulta === "0") {
                return true;
            }

        }

        return false;

    }

    getMenu_Operaciones = async () => {

        const menuOperaciones = await getMenuOperaciones();
        console.log(menuOperaciones);

        if (menuOperaciones) {
            this.setState({ menuOperaciones });
        }
    }

    getDateMenuExterior = async () => {
        const dataMenuE = await getData_menuExterior();

        const configLumina = dataMenuE
            && dataMenuE.configLumina.activo ? true : false;
        this.setState({ dataMenuExterior: dataMenuE, configLumina });
    }

    checkPermiso = (id) => {

        if (this.state.menuOperaciones) {

            const mo = this.state.menuOperaciones.filter((i) => i.id === id);

            if (mo.length && mo[0].habilitado) {
                return true;
            }

            return false;
        }

        return true;
    }


    render() {
       
        let { rendimientos, servicios, currentContrato } = this.props;

        if (rendimientos) {
            rendimientos = rendimientos.TTRENDIMIENTO['TT-RENDIMIENTO'];

            rendimientos.sort((a, b) => new Date(a.Fecha) - new Date(b.Fecha));
        }

        let permiteCompraVenta = true;

        if (servicios && servicios.length) {
            const sf = servicios.filter((v) => {
                if (v.id === "E" && v.NoEsUsuario) {
                    return v;
                }
            });

            if (sf.length) {
                permiteCompraVenta = false;
            }

        }


        return (
            <div className="row">
                <div className="col s12 m12 l4 xl4 ">
                    {
                        rendimientos === undefined || rendimientos === null ?

                            <div className="row">

                                <ul className="collection with-header posicionCartera z-depth-2">
                                    <li className="collection-header">

                                        <div className="row">
                                            <div className="col s12 center-align">
                                                <Reload action={() => { }} />
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div> :
                            <PosicionCartera
                                rendimientos={rendimientos} servicios={servicios} esLumina={this.state.configLumina} />
                    }

                </div>
                <div className="col s12 m12 l8 xl8">
                    <div className="row flex paddingOperaciones">
                        <div className="col s12 m12 l5 xl5 rendimientoTotal paddingRigth20">
                            {
                                rendimientos === undefined || rendimientos === null ?
                                
                                    <div className="row contentBarChart">
                                        <div className="col s12 center-align mt-1">
                                            <Reload action={() => { }} />
                                        </div>
                                    </div>
                                    :

                                    <div className="row contentBarChart">
                                        {
                                            rendimientos ?

                                                <div className="col s12">
                                                    <p>Rendimiento neto efectivo del mes de

                                                        {" " + getMonthStringGraphs(parseInt(rendimientos[0].Fecha.split("-")[1]))
                                                            + " "
                                                            + rendimientos[0].Fecha.split("-")[0]} <span>
                                                            <i className="material-icons tooltipped cursorPointer"
                                                                data-position="bottom" data-tooltip="Si desea conocer su rendimiento anualizado consulte a su promotor."
                                                            >info_outline</i></span>
                                                    </p>
                                                    <div className="center-align percentRendimientoTotal txtSky">
                                                        {
                                                            rendimientos ?
                                                                `${parseFloat(rendimientos[0].Rendimiento).toFixed(6)}%`
                                                                : null
                                                        }
                                                    </div>
                                                </div> : null

                                        }


                                        {
                                            rendimientos ?
                                                <div className="col s12 align-left NavyPrimary mt-1">
                                                    Rendimiento neto efectivo de meses anteriores
                                                </div>
                                                : null
                                        }

                                        <div className={`col s12 mt-1 ${!rendimientos ? 'center-align SinRendimientos' : ''}`} >
                                            {
                                                rendimientos ?

                                                    <Bar

                                                        data={{
                                                            labels: rendimientos.map(item => getMonthStringGraphs(parseInt(item.Fecha.split("-")[1]))
                                                                + " "
                                                                + item.Fecha.split("-")[0]),
                                                            datasets: [{
                                                                label: '',
                                                                data: rendimientos.map(item => item.Rendimiento),
                                                                backgroundColor: [
                                                                    '#BFDD7E',
                                                                    '#B487B8',
                                                                    '#FFCD00',
                                                                    '#9EC8FF'
                                                                ],
                                                                borderColor: [
                                                                    '#BFDD7E',
                                                                    '#B487B8',
                                                                    '#FFCD00',
                                                                    '#9EC8FF'
                                                                ],
                                                                borderWidth: 1,
                                                            }]
                                                        }}

                                                        options={{
                                                            scales: {
                                                                yAxes: [{
                                                                    ticks: {
                                                                        beginAtZero: true,
                                                                        callback: function (value, index, values) {
                                                                            return value + '%';
                                                                        }
                                                                    }
                                                                }]
                                                            },
                                                            legend: {
                                                                labels: {
                                                                    boxWidth: 0,
                                                                    padding: 0

                                                                },
                                                                onClick: (e) => {
                                                                    e.stopPropagation();
                                                                },
                                                                display: true,
                                                            },
                                                            plugins: {

                                                                labels: {
                                                                    render: (args) => {
                                                                        return args.value + '%'
                                                                    },
                                                                },
                                                            },
                                                            tooltips: {
                                                                callbacks: {
                                                                    label: function (tooltipItem, data) {
                                                                        var dataset = data.datasets[tooltipItem.datasetIndex];
                                                                        var currentValue = dataset.data[tooltipItem.index];
                                                                        return ' (' + currentValue + '%)';
                                                                    },
                                                                    title: function (tooltipItem, data) {
                                                                        return data.labels[tooltipItem[0].index];
                                                                    }
                                                                }
                                                            }
                                                        }}

                                                        type="bar"

                                                    />
                                                    : "Sin información de rendimientos"
                                            }

                                        </div>
                                    </div>
                            }
                        </div>
                        {/* OPERACIONES */}
                        <div className="col s12 m12 l7 xl7 rendimientoTotal">
                            <div className="row contentBarChart">
                                <div className="col s12 mb-10 mt-10">
                                    <span>Operaciones</span>
                                </div>
                                {
                                    this.checkPermiso("comprar") && (
                                        <div className="col s6 center-align">
                                            <div className="row optRowContainer">
                                                <div className="col s12 optContainer waves-effect"
                                                    onClick={() => {
                                                        if (this.props.currentContrato.OperaCompra === "0") {
                                                            this.setState({
                                                                imgModal: ICONS.COMPRA_NO_PERMITIDA
                                                            }, () => {
                                                                this.showModalOperacionPerm();
                                                            })

                                                            return;
                                                        }

                                                        if (this.props.dataUser.Inhabil === 0 && this.checkOpera()) {
                                                            this.props.setOperacion({ opt: "comprar", title: "Comprar" });
                                                        } else {
                                                            let propsOkButton = {
                                                                //message: currentContrato.Consulta === "1" ? TEXTOS.CONTRATO_SOLO_CONSULTA : TEXTOS.NO_PERMITE_COMPRA_VENTA.message,
                                                                message: TEXTOS.CONTRATO_SOLO_CONSULTA,
                                                                title: TEXTOS.NO_PERMITE_COMPRA_VENTA.title,
                                                                txtButton: TEXTOS.NO_PERMITE_COMPRA_VENTA.txtButton,
                                                                statusCode: 404
                                                            };
                                                            if (this.props.dataUser.Inhabil !== 0) {
                                                                propsOkButton = TEXTOS.DIA_INHABIL;
                                                            }
                                                            this.props.okButton(propsOkButton);
                                                        }

                                                    }}
                                                >
                                                    <p className="noMBottom"><img src={ICONS.CARD} alt="hide" className="optOperacion"></img></p>
                                                    <p className="optOperacionTxt noMTop">Comprar</p>
                                                </div>
                                            </div>

                                        </div>

                                    )
                                }
                                {
                                    this.checkPermiso("vender") && (
                                        <div className="col s6 center-align">
                                            <div className="row optRowContainer">
                                                <div className="col s12 optContainer waves-effect"
                                                    onClick={() => {

                                                        if (this.props.currentContrato.OperaVenta === "0") {
                                                            this.setState({
                                                                imgModal: ICONS.VENTA_NO_PERMITIDA
                                                            }, () => {
                                                                this.showModalOperacionPerm();
                                                            })

                                                            return;
                                                        }
                                                        // if (permiteCompraVenta && this.props.dataUser.Inhabil === 0 && currentContrato.Consulta === "0") {
                                                        if (this.props.dataUser.Inhabil === 0 && this.checkOpera()) {
                                                            this.props.setOperacion({ opt: "vender", title: "Vender" });
                                                        } else {
                                                            let propsOkButton = {
                                                                //message: currentContrato.Consulta === "1" ? TEXTOS.CONTRATO_SOLO_CONSULTA : TEXTOS.NO_PERMITE_COMPRA_VENTA.message,
                                                                message: TEXTOS.CONTRATO_SOLO_CONSULTA,
                                                                title: TEXTOS.NO_PERMITE_COMPRA_VENTA.title,
                                                                txtButton: TEXTOS.NO_PERMITE_COMPRA_VENTA.txtButton,
                                                                statusCode: 404
                                                            };
                                                            if (this.props.dataUser.Inhabil !== 0) {
                                                                propsOkButton = TEXTOS.DIA_INHABIL;
                                                            }
                                                            this.props.okButton(propsOkButton);
                                                        }
                                                    }}
                                                >
                                                    <p className="noMBottom"><img src={ICONS.EXPENSIVE} alt="hide" className="optOperacion"></img></p>
                                                    <p className="optOperacionTxt noMTop">Vender</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                {
                                    this.checkPermiso("depositar_contrato") && (
                                        <div className="col s6 center-align">
                                            <div className="row optRowContainer">
                                                <div className="col s12 optContainer waves-effect"
                                                    onClick={() => {
                                                        if (this.props.dataUser.Inhabil === 0 && this.checkOpera()) {
                                                            this.props.setOperacion({ opt: "desposito_contrato", title: "Depositar a mi contrato" });
                                                        } else {


                                                            let propsOkButton = {
                                                                message: TEXTOS.CONTRATO_SOLO_CONSULTA,
                                                                title: TEXTOS.NO_PERMITE_COMPRA_VENTA.title,
                                                                txtButton: TEXTOS.NO_PERMITE_COMPRA_VENTA.txtButton,
                                                                statusCode: 404
                                                            };
                                                            this.props.okButton(propsOkButton);


                                                        }

                                                    }}
                                                >
                                                    <p className="noMBottom"><img src={ICONS.WINS} alt="hide" className="optOperacion"></img></p>
                                                    <p className="optOperacionTxt noMTop">Depositar a mi contrato</p>
                                                </div>
                                            </div>
                                        </div>)

                                }

                                {
                                    this.checkPermiso("retirar_contrato") && (
                                        <div className="col s6 center-align">
                                            <div className="row optRowContainer">
                                                <div className="col s12 optContainer waves-effect"
                                                    onClick={() => {
                                                        if (this.props.dataUser.Inhabil === 0 && this.checkOpera()) {
                                                            this.props.setOperacion({ opt: "retiro_contrato", title: "Retirar de mi contrato" })
                                                        } else {


                                                            let propsOkButton = {
                                                                message: TEXTOS.CONTRATO_SOLO_CONSULTA,
                                                                title: TEXTOS.NO_PERMITE_COMPRA_VENTA.title,
                                                                txtButton: TEXTOS.NO_PERMITE_COMPRA_VENTA.txtButton,
                                                                statusCode: 404
                                                            };
                                                            this.props.okButton(propsOkButton);

                                                        }

                                                    }}
                                                >
                                                    <p className="noMBottom"><img src={ICONS.ATM} alt="hide" className="optOperacion"></img></p>
                                                    <p className="optOperacionTxt noMTop">Retirar de mi contrato</p>
                                                </div>
                                            </div>
                                        </div>)}

                                {
                                    this.state.configLumina && this.checkPermiso("operaciones_pendientes") ?

                                        <div className="col s6 center-align">
                                            <div className="row optRowContainer">
                                                <div className="col s12 optContainer waves-effect"
                                                    onClick={() => {

                                                        if (this.props.dataUser.Inhabil === 0 && this.checkOpera()) {
                                                            this.props.showOrdenesPendientes(true);
                                                        } else {



                                                            let propsOkButton = {
                                                                message: TEXTOS.CONTRATO_SOLO_CONSULTA,
                                                                title: TEXTOS.NO_PERMITE_COMPRA_VENTA.title,
                                                                txtButton: TEXTOS.NO_PERMITE_COMPRA_VENTA.txtButton,
                                                                statusCode: 404
                                                            };
                                                            this.props.okButton(propsOkButton);

                                                        }


                                                    }}
                                                >
                                                    <p className="noMBottom"><img src={ICONS.PENDIENTES} alt="hide" className="optOperacion"></img></p>
                                                    <p className="optOperacionTxt noMTop">Ordenes Pendientes</p>
                                                </div>
                                            </div>
                                        </div> : null
                                }

                                <div className="col s12 mb-10">
                                    <span>Información</span>
                                </div>
                                <div className="col s6 center-align">
                                    <div className="row optRowContainer">
                                        <div className="col s12 optContainer waves-effect"
                                            onClick={() => {
                                                this.props.setOperacion({ opt: "movimientos", title: "Movimientos" })
                                            }}
                                        >
                                            <p className="noMBottom"><img src={ICONS.MOVINGS} alt="hide" className="optOperacion"></img></p>
                                            <p className="optOperacionTxt noMTop">Movimientos</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col s6 center-align">
                                    <div className="row optRowContainer">
                                        <div className="col s12 optContainer waves-effect"
                                            onClick={() => {
                                                this.props.setOperacion({ opt: "documentos", title: "Documentos" })
                                            }}
                                        >
                                            <p className="noMBottom"><img src={ICONS.DOCS} alt="hide" className="optOperacion"></img></p>
                                            <p className="optOperacionTxt noMTop">Documentos</p>
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.dataMenuExterior
                                        && this.state.dataMenuExterior.depositos
                                        && this.state.dataMenuExterior.depositos.show_transferencia_spei ?
                                        <div className="col s6 center-align">
                                            <div className="row optRowContainer">
                                                <div className="col s12 optContainer waves-effect"
                                                    onClick={() => {
                                                        if (!currentContrato.clabeInterbancaria || currentContrato.clabeInterbancaria === '') {
                                                            this.props.okButton({
                                                                message: "Su contrato no tiene una cuenta CLABE asignada. Por favor, contacte a su promotor.", title: "¡Sin información disponible!", txtButton: "Entendido",
                                                                title_close: "Cuenta CLABE",
                                                                statusCode: "404_clabe"
                                                            });
                                                        } else {
                                                            this.props.setOperacion({ opt: "cuenta_clabe", title: "Cuenta CLABE", data: { cuentaBancariaDeposito: this.props.currentContrato.clabeInterbancaria } });
                                                        }

                                                    }}
                                                >
                                                    <p className="noMBottom"><img src={ICONS.CUENTA_CLABE} alt="hide" className="optOperacion"></img></p>
                                                    <p className="optOperacionTxt noMTop">Cuenta CLABE</p>
                                                </div>
                                            </div>
                                        </div>
                                        : null

                                }
                            </div>
                        </div>
                    </div>
                    <div className="row paddingOperaciones ">
                        <DivisasIndicesAcciones />
                    </div>
                </div>

                <div id="moda_opera_perm" className={`modal`}>
                    <div className='row'>
                        <div className='col s12 center-align'>
                            <img src={this.state.imgModal} alt="lock" className="responsive-img" ></img>
                        </div>
                        <div className='col s12 center-align mt-1'>
                            <button className="modal-close waves-effect btn primaryBtn"
                                onClick={() => {
                                    let instance = M.Modal.getInstance(document.getElementById('moda_opera_perm'));

                                    if (instance) {
                                        instance.close();
                                    }
                                }}
                            >Entendido</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    let { dataUser, currentContrato, menuPerfil, contratosUser,
        chequera, history, saldoTotal, servicios, rendimientos, tiposServiciosOpera
    } = false;
    if (state.servicesActions) {
        dataUser = state.servicesActions.dataUser || false;
        currentContrato = state.servicesActions.currentContrato || false
        contratosUser = state.servicesActions.contratosUser || false
        chequera = state.servicesActions.chequera || false
    }

    if (state.commonsActions) {
        menuPerfil = state.commonsActions.menuPerfil || false;
        history = state.commonsActions.history || false;
        saldoTotal = state.commonsActions.saldoTotal || 0;
        rendimientos = state.commonsActions.rendimientos || false;
        servicios = state.commonsActions.tiposServicios || false;
        tiposServiciosOpera = state.commonsActions.tiposServiciosOpera || false;
    }

    return {
        dataUser,
        currentContrato,
        menuPerfil,
        contratosUser,
        chequera,
        history,
        saldoTotal,
        servicios,
        rendimientos,
        tiposServiciosOpera
    };
};

export default connect(mapStateToProps,
    {
        setHistory,
        setDataUser,
        setContratos,
        setCurrentContrato,
        setOperacion,
        setChequera,
        okButton,
        setTiposServicios,
        showOrdenesPendientes
    }
)(Graphs)